module.exports = __webpack_public_path__ + "static/028.thumb-1c791d3e24447bd0eac3071a5f054506.jpg";